import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const scholarshipsCarousels = document.querySelectorAll(
    '.scholarships-carousel-block .scholarships-carousel__carousel'
  );

  if (scholarshipsCarousels.length > 0) {
    scholarshipsCarousels.forEach((carousel) => {
      const nextElement = carousel.querySelector('.vtx-swiper__next');
      const prevElement = carousel.querySelector('.vtx-swiper__prev');
      const paginationEl = carousel.querySelector('.vtx-swiper__pagination');

      new Swiper(carousel, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        pagination: {
          el: paginationEl,
          type: 'fraction',
        },
        navigation: {
          nextEl: nextElement,
          prevEl: prevElement,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          1080: {
            slidesPerView: 3.1,
          },
          1920: {
            slidesPerView: 4,
          },
        },
      });
    });
  }
});
